/**
 * 日付ユーティリティクラス
 */
export default class DateUtils {
    /** インスタンス */
    private static _instance: DateUtils

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new DateUtils();
        }
        return this._instance;
    }

    /**
     * 現在の日時を取得する
     */
    private now() {
        const now = new Date()
        /* ISO書式で日本時間になるように時間をずらす */
        now.setTime(now.getTime() + 1000 * 60 * 60 * 9)
        return now
    }

    /**
     * 今日の日付(yyyy-MM-dd)を取得する
     */
    public getToday() {
        return this.now().toISOString().substr(0, 10)
    }

    /**
     * 日付書式(yyyy/MM/dd)で取得する
     * @param date yyyy-MM-dd形式
     */
    public toJapanFormat(date: string | null) {
        return date === null ?  "" : date.replace(/-/g, "/")
    }

    /**
     * 日付書式(yyyy/MM/dd)で取得する
     * @param date yyyy-MM-dd形式
     */
    public toISOFormat(date: string | null) {
        return date === null ?  "" : date.replace(/\//g, "-")
    }

    /**
     * 年の加算
     * @param date
     * @param amount 
     */
    public addYear(date: string, amount: number) {
        const dt = new Date(`${date} 09:00:00`)
        dt.setFullYear(dt.getFullYear() + amount)
        return dt.toISOString().substr(0, 10)
    }

    /**
     * 月の加算
     * @param date
     * @param amount 
     */
    public addMonth(date: string, amount: number) {
        const dt = new Date(`${date} 09:00:00`)
        dt.setMonth(dt.getMonth() + amount)
        return dt.toISOString().substr(0, 10)
    }

    /**
     * 日の加算
     * @param date
     * @param amount 
     */
    public addDate(date: string, amount: number) {
        const dt = new Date(`${date} 09:00:00`)
        dt.setDate(dt.getDate() + amount)
        return dt.toISOString().substr(0, 10)
    }

    /**
     * 月末日を取得
     * @param date
     */
    public lastDate(date: string) {
        const dt = new Date(`${date} 09:00:00`)
        dt.setMonth(dt.getMonth() + 1)
        dt.setDate(0)
        return dt.toISOString().substr(0, 10)
    }

    /**
     * 経過日数
     * @param date yyyy-MM-dd形式
     */
    public elapsedDays(date: string) {
        const now = new Date(`${this.getToday()} 00:00:00`)
        const target = new Date(`${date} 00:00:00`)
        return (now.valueOf() - target.valueOf()) / (24 * 60 * 60* 1000)
    }

    /**
     * 現在日付を指定書式に変換する
     * @param date
     * @param format 
     */
    public format(date = this.getToday(), format: string) {
        const yyyy = date.substr(0, 4)
        const yy = date.substr(2, 2)
        const mm = date.substr(5, 2)
        const dd = date.substr(8, 2)
        return format.replace("yyyy", yyyy)
                    .replace("yy", yy)
                    .replace("MM", mm)
                    .replace("dd", dd)
    }

}
